import { render, staticRenderFns } from "./PatentStructure.vue?vue&type=template&id=47a3411a"
import script from "./PatentStructure.vue?vue&type=script&lang=js"
export * from "./PatentStructure.vue?vue&type=script&lang=js"
import style0 from "./PatentStructure.vue?vue&type=style&index=0&id=47a3411a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports